// extracted by mini-css-extract-plugin
export default {"title":"HomeText_title__5Ktrp","text":"HomeText_text__F5+EZ","rotatingText":"HomeText_rotatingText__gUY4d"};